// import type { App } from "vue";

import { setupElIcons } from "./icons";
import { setupSvgIcons } from "./svg";
import { setupStore } from "@/stores";
import { setupPermission } from "./permission";

export default {
  install(app) {
    setupElIcons(app);
    setupSvgIcons(app);
    setupStore(app);
    setupPermission();
  },
};
